
import { Blog } from "./components/Blog";
 
import { Home } from "./components/Home";

import { Photos } from "./components/Photos";
import Poker from "./components/Poker";
import Games from "./components/Games";
import LocalFavorites from "./components/LocalFavorites";
import Developer from "./components/Developer";
const AppRoutes = [
  {
    index: true,
    element: <Home />
  },
  {
    path: '/blog',
    element: <Blog />
    },
    {
        path: '/Photos',
        element: <Photos />
    },
    {
        path: '/LocalFavorites',
        element: <LocalFavorites />
    },
    {
        path: '/Poker',
        element: <Poker />
    },
    {
        path: '/Games',
        element: <Games />
    }
    ,
    {
        path: '/Developer',
        element: <Developer />
    }
  
];

export default AppRoutes;
